<div class="container">
  <div class="avatar">
    <app-avatar class="avatar-md w-24 flex-none mr-7"
                [url]="friend.avatar?.url ?? ''"
                [name]="friend.fullName"
    ></app-avatar>
  </div>
  <div class="friend-info">
    <h3 class="name">{{ friend.fullName }}</h3>
    <p class="username"> {{ friend.email }}</p>
  </div>

  <div class="actions">
    <mat-checkbox class="text-blue" [checked]="checked" (change)="toggleSelection($event, friend.id)" ></mat-checkbox>
  </div>
</div>
